
		import Async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function (require) {
				cb( require("!!../../../node_modules/babel-loader/lib/index.js??ref--0!./index.js") );
			}, "route-Loading");
		}

		export default Async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/Loading/index.js
// module id = null
// module chunks = 